const userAgent = window.navigator.userAgent;

const detector = {
  isJDJR: !!userAgent.toLowerCase().match(/jdjr-app/i),
  // interface_ActCode: '3F6F973E69', // 测试环境code
  interface_ActCode: '917426B264' // 生产环境code
};

export { userAgent };
export default detector;
